/* tslint:disable */
/* eslint-disable */
/**
 * Generali TechEx Services API
 *  Generali TechEx Services Python API. ## References * [Pricing Tools](https://gptdoc.etractive.de/build/design-pfm/) * [Excel Add-In](https://gptdoc.etractive.de/build/ms365/) 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: info@techex.generali.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormulaEvaluateValue } from './FormulaEvaluateValue';
import {
    FormulaEvaluateValueFromJSON,
    FormulaEvaluateValueFromJSONTyped,
    FormulaEvaluateValueToJSON,
    FormulaEvaluateValueToJSONTyped,
} from './FormulaEvaluateValue';
import type { FormulaEvaluateTableInput } from './FormulaEvaluateTableInput';
import {
    FormulaEvaluateTableInputFromJSON,
    FormulaEvaluateTableInputFromJSONTyped,
    FormulaEvaluateTableInputToJSON,
    FormulaEvaluateTableInputToJSONTyped,
} from './FormulaEvaluateTableInput';
import type { FormulaEvaluateDebugInfo } from './FormulaEvaluateDebugInfo';
import {
    FormulaEvaluateDebugInfoFromJSON,
    FormulaEvaluateDebugInfoFromJSONTyped,
    FormulaEvaluateDebugInfoToJSON,
    FormulaEvaluateDebugInfoToJSONTyped,
} from './FormulaEvaluateDebugInfo';

/**
 * 
 * @export
 * @interface FormulaEvaluateResponse
 */
export interface FormulaEvaluateResponse {
    /**
     * 
     */
    durationMs?: number;
    /**
     * 
     */
    requestId?: string;
    /**
     * 
     */
    methods?: Array<string>;
    /**
     * 
     */
    tables?: Array<FormulaEvaluateTableInput>;
    /**
     * 
     */
    values?: Array<FormulaEvaluateValue>;
    /**
     * 
     */
    debugInfo?: FormulaEvaluateDebugInfo;
}

/**
 * Check if a given object implements the FormulaEvaluateResponse interface.
 */
export function instanceOfFormulaEvaluateResponse(value: object): value is FormulaEvaluateResponse {
    return true;
}

export function FormulaEvaluateResponseFromJSON(json: any): FormulaEvaluateResponse {
    return FormulaEvaluateResponseFromJSONTyped(json, false);
}

export function FormulaEvaluateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaEvaluateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'durationMs': json['durationMs'] == null ? undefined : json['durationMs'],
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
        'methods': json['methods'] == null ? undefined : json['methods'],
        'tables': json['tables'] == null ? undefined : ((json['tables'] as Array<any>).map(FormulaEvaluateTableInputFromJSON)),
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(FormulaEvaluateValueFromJSON)),
        'debugInfo': json['debugInfo'] == null ? undefined : FormulaEvaluateDebugInfoFromJSON(json['debugInfo']),
    };
}

export function FormulaEvaluateResponseToJSON(json: any): FormulaEvaluateResponse {
    return FormulaEvaluateResponseToJSONTyped(json, false);
}

export function FormulaEvaluateResponseToJSONTyped(value?: FormulaEvaluateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'durationMs': value['durationMs'],
        'requestId': value['requestId'],
        'methods': value['methods'],
        'tables': value['tables'] == null ? undefined : ((value['tables'] as Array<any>).map(FormulaEvaluateTableInputToJSON)),
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(FormulaEvaluateValueToJSON)),
        'debugInfo': FormulaEvaluateDebugInfoToJSON(value['debugInfo']),
    };
}

